import React from 'react';
import { Icon, IconButton, Table3, Tooltip } from '@economic/taco';
import { t } from '@lingui/macro';
import { Link } from 'react-router-dom';

import number from '~/app/shared/util/utilities/number';
import { PartialInvoiceDto } from '~/types/internal-api';
import date from '~/app/shared/util/utilities/date';

interface Props {
    data: PartialInvoiceDto[];
}
export default function PartialInvoicesTable({ data }: Props) {
    return (
        <Table3<PartialInvoiceDto>
            data={data}
            id="partial-invoices-table"
            preset="display"
            enableFiltering={false}
            enableSearch={false}
            enableColumnFreezing={false}
            enableColumnHiding={false}
            enableColumnOrdering={false}
            enableFontSize={false}
            enableRowHeight={false}
            enableRowSelection={false}
            enableRowExpansion={false}>
            <Table3.Column<PartialInvoiceDto>
                accessor="invoiceId"
                header={t`Partial invoice no.`}
                renderer={(value, row) => (
                    <>
                        {row.booked ? (
                            <Tooltip title={t`Show invoice`}>
                                <IconButton
                                    icon="document-preview"
                                    appearance="discrete"
                                    aria-label="Show invoice"
                                    className="-mt-1"
                                    onClick={() => {
                                        window.top?.PopUp2(
                                            `../include/visfaktura.asp?bogf=1&faknr=${value}`,
                                            0.8 * window.screen.height * 0.75,
                                            0.8 * window.screen.height
                                        );
                                    }}
                                />
                            </Tooltip>
                        ) : (
                            <IconButton
                                icon="document-preview"
                                appearance="discrete"
                                disabled
                                aria-label="Show invoice disabled"
                                className="-mt-1"
                            />
                        )}
                        {row.booked ? value : <Link to={`/sales/invoicing/invoices/${value}`}>{value}</Link>}
                    </>
                )}
            />
            <Table3.Column<PartialInvoiceDto>
                accessor="date"
                header={t`Date`}
                renderer={value => {
                    const renderValue = date.format(date.parseFromISOString(value));
                    if (renderValue === undefined) {
                        return '';
                    }
                    return renderValue;
                }}
            />
            <Table3.Column
                accessor="booked"
                header={t`Booked`}
                align="center"
                renderer={value => value && <Icon name="tick" />}
            />
            <Table3.Column<PartialInvoiceDto>
                accessor="amount"
                header={t`Amount`}
                align="right"
                renderer={value => number.format(value)}
            />
        </Table3>
    );
}
